import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';

import CrowdNavigation 		from '../common/_CrowdNavigation.jsx';
import {BDPGlyph} from '../common/_BDPLogo.jsx';

export default class CrowdInstructions extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.projects = blapp.models.get( "instructions" );
	}

	render() {
		return (
			<React.Fragment>
				{!blapp.config.isDesktopMode() ? this.renderNav() : null}
				<div className="main">
					<div className="main__content">
						{this.renderHeader()}
						{this.renderInstructionsR1()}
						{this.renderInstructionsR2()}
						{this.renderFooter()}
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderNav() {
		return (
			<CrowdNavigation classes="l-border--bottom" page={6}/>
		);
	}

	renderHeader() {
		return (
			<header className={"edge-to-edge-container crowd-help__header"}>
				<div className={"edge-to-edge-container__internal crowd-help__header-internal l-block"}>
					<div className="bdp-glyph-circle">
						<BDPGlyph/>
					</div>
					<h1 className="crowd-help__header-title bdp-instructions-header__title text--center">Downloadable Building Instructions</h1>
				</div>
			</header>
		);
	}

	renderInstructionsR1() {
		const projectCardsR1 = this.projects.filter(p => p.nCrowdfundingRound == 1).map(project => this.returnCard(project));

		return (
			<section className="bdp-instructions-section">
				<h2 className="bdp-instructions-section__title">Round 1</h2>
				<div className="mdc-layout-grid l-pad-null">
					<div className="mdc-layout-grid__inner bdp-introduce__projects-grid">
						{projectCardsR1}
					</div>
				</div>
			</section>
		);
	}
	renderInstructionsR2() {
		const projectCardsR2 = this.projects.filter(p => p.nCrowdfundingRound == 2).map(project => this.returnCard(project));

		return (
			<section className="bdp-instructions-section">
				<h2 className="bdp-instructions-section__title">Round 2</h2>
				<div className="mdc-layout-grid l-pad-null">
					<div className="mdc-layout-grid__inner bdp-introduce__projects-grid">
						{projectCardsR2}
					</div>
				</div>
			</section>
		);
	}

	renderFooter() {
		return (
			<article className="notification notification--warning l-flex l-start text--small-title l-margin-y--xl">
				<i className="fas fa-question-circle l-margin-top--sm l-margin-right"/>
				<div>
					<h1 className="text--bold">Building instructions for future rounds will be released after the sets have been shipped to customers. </h1>
					<p>Check back for Round 3 in Q1 2023.</p>
				</div>
			</article>
		);
	}

	returnCard(project) {
		return (
			<article key={project.idModel} className="card mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-desktop-l mdc-layout-grid__cell--span-4-small-screen mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
				<div className="card__internal bdp-card bdp-instructions-card">
					<a href={project.url} target="_blank" className="bdp-instructions-card__image">
						<div className="bdp-instructions-card__image-internal">
							<img className="bdp-instructions-card__image-item" src={project.dmMainImage.url}/>
						</div>
					</a>
					<div className="bdp-instructions-card__content">
						<p className="bdp-instructions-card__id">{project.idModel}</p>
						<h1 className="bdp-instructions-card__name">{project.strModelName}</h1>
						<div className="bdp-instructions-card__author simple-profile-card text--no-wrap l-flex-no-shrink">
							<div className="simple-profile-card__image simple-profile-card__image--small l-margin-right--md">
								<img src={blapp.url2.getProfileImgUrl(project.dmUserBuilder, 'medium')} className="simple-profile-card__image-item l-full-width"/>
							</div>
							<span className="simple-profile-card__name">{project.dmUserBuilder.skUsername}</span>
						</div>
						<a href={project.strURL} target="_blank" className="bdp-instructions-card__button-container" onClick={() => this.trackDownload(project.idModel)}>
							<div className="btn bdp-instructions-card__button">
								<i className="fas fa-download bdp-instructions-card__button-icon"/>
								<div>
									<p className="bdp-instructions-card__button-title">Download instructions</p>
									<p>PDF file, {(project.nFileSize/1048576).toFixed(2)} MB</p>
								</div>
							</div>
						</a>
						{project.udtUpdated &&
						<div className="text--note">Last updated: {blapp.format.formatDateTime(project.udtUpdated)}</div>
						}
					</div>
				</div>
			</article>
		);
	}

	trackDownload(idModel)
	{
		blapp.track.trackGeneral( 10101, idModel );
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<CrowdInstructions blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-crowd' )
						);
		blapp.refs.register( "main", elem );
	}
);